// Version : 0.0.1
// Author :
// LastEdit : VISHAL BHARATHI
// Last ADD : UNNECESSARY PARTS REMOVED
// MODIFIED DATE: 19-09-2025

import WalletReportActionTypes from './wallet-report.types';

/** ***************** GET GROUP MEMBER DETAILS START *********************** */
export const fetchGroupMemberDetailsStart = (getData: any) => ({
	type: WalletReportActionTypes.FETCH_GROUP_MEMBER_START,
	payload: getData,
});

export const fetchGroupMemberDetailsSuccess = (successData: any) => ({
	type: WalletReportActionTypes.FETCH_GROUP_MEMBER_SUCCESS,
	payload: successData,
});

export const fetchGroupMemberDetailsFailure = (failureData: any) => ({
	type: WalletReportActionTypes.FETCH_GROUP_MEMBER_FAILURE,
	payload: failureData,
});

export const fetchGroupMemberDetailsResponseReset = () => ({
	type: WalletReportActionTypes.FETCH_GROUP_MEMBER_RESPONSE_RESET,
});

export const fetchGroupMemberDetailsResponseChanged = () => ({
	type: WalletReportActionTypes.FETCH_GROUP_MEMBER_RESPONSE_CHANGED,
});
/** ***************** GET GROUP MEMBER DETAILS END *********************** */

/** ***************** GET WALLET REPORT DETAILS START *********************** */
export const fetchWalletReportStart = (getData: any) => ({
	type: WalletReportActionTypes.FETCH_WALLET_REPORT_START,
	payload: getData,
});

export const fetchWalletReportSuccess = (successData: any) => ({
	type: WalletReportActionTypes.FETCH_WALLET_REPORT_SUCCESS,
	payload: successData,
});

export const fetchWalletReportFailure = (failureData: any) => ({
	type: WalletReportActionTypes.FETCH_WALLET_REPORT_FAILURE,
	payload: failureData,
});

export const fetchWalletReportResponseReset = () => ({
	type: WalletReportActionTypes.FETCH_WALLET_REPORT_RESPONSE_RESET,
});

export const fetchWalletReportResponseChanged = () => ({
	type: WalletReportActionTypes.FETCH_WALLET_REPORT_RESPONSE_CHANGED,
});

/** ***************** GET WALLET REPORT DETAILS END *********************** */
